// @flow

/*
 * This is a Container file that can be used to abstract business logic and
 * provide it to the Component (Lightbox.js) via the same API across all
 * platforms. For instance, to share this logic in React Native, simply create
 * Lightbox.ios.js and Lightbox.android.js files, and the RN build process will
 * automatically use those for compiling the app (instead of the Lightbox.js
 * HTML/web version).
 *
 * `recompose` can be used to abstract React lifecycle methods or component
 * methods into this file as well if code re-use warrants it.
 */
import Lightbox from "./Lightbox";

/*
 * Types can be defined in the Container to enforce the props API across all platforms
 */
type OwnProps = {||};

// Redux...when used
type StateProps = {||};
type DispatchProps = {||};

/*
 * Since we don't have any shared business logic, simply exporting the
 * component will allow us to always import the component directory
 * (src/components/ComponentName) in either the routes file or any other
 * component import.
 */
export default Lightbox;
export type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};



// WEBPACK FOOTER //
// ./src/components/Lightbox/index.js